var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"wrapper"},[_c('div',{ref:"marquee",class:_vm.marqueeClassName,style:({
            '--overflow-width': _vm.overflowWidth, 
            '--animation-duration': _vm.animationDuration, 
            '--padding': _vm.padding,
            '--divider-padding': _vm.dividerPadding
        })},_vm._l((_vm.items),function(item,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(item)+" "),(index < _vm.items.length - 1)?_c('span',{staticClass:"divider"},[_vm._v(_vm._s(_vm.divider))]):_vm._e()])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }